export default function TimeDisplay({ currenttime, extraClass, is_max, is_min, is_eco = false }) {
    const formatTime = (val, ...rest) => {

        let value = val.toString();
        if (value.length < 2) {
            value = '0' + value;
        }
        if (rest[0] === 'ms' && value.length < 3) {
            value = '0' + value;
        }
        return value;
    };

    return (
        <div className={is_max ? 'max-index time-display-container' : is_min ? 'min-index time-display-container' : 'time-display-container'} >
            <div className={`stopwatch__display ${extraClass}`}>
                <span> {formatTime(currenttime.currentTimeHr)}</span>:
                <span>{formatTime(currenttime.currentTimeMin)}</span>:
                <span className={is_eco ? "span_display" : ""}>{formatTime(currenttime.currentTimeSec)}</span>
                {!is_eco && <span className="span_display" >  .{formatTime(currenttime.currentTimeMs, 'ms')}</span>}
            </div>
        </div >
    );

}
